// Ouvre les sous-menus au survol sur desktop uniquement
(() => {
  const isHoverable = window.matchMedia('(hover: hover)').matches;
  if (!isHoverable) return; // Ne touche pas au mobile

  const details = document.querySelectorAll('header details');
  details.forEach(d => {
    d.addEventListener('mouseenter', () => d.setAttribute('open', ''));
    d.addEventListener('mouseleave', () => d.removeAttribute('open'));
  });
})();

